export default __webpack_public_path__ + "assets/images/banner-explorer.13d07fdf.png";